import React from 'react';
import PropTypes from 'prop-types';

export default function DashboardIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 147999' />
      <path
        fill={fill}
        d='M17.364 2H2.636A1.717 1.717 0 0 0 1 3.778v10.666a1.717 1.717 0 0 0 1.636 1.778h4.091V18h6.545v-1.778h4.091a1.71 1.71 0 0 0 1.628-1.778L19 3.778A1.717 1.717 0 0 0 17.364 2Zm0 12.444H2.636V3.778h14.728Zm-1.636-8h-9v1.778h9Zm0 3.556h-9v1.778h9ZM5.909 6.444H4.273v1.778h1.636Zm0 3.556H4.273v1.778h1.636Z'
      />
    </svg>
  );
}

DashboardIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

DashboardIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
